/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { Table } from 'antd';
import styles from './styles.module.css';

const CommonTable = ({
  columns,
  dataSource,
  pagination = false,
  bordered = true,
  size = 'middle',
  scroll = { x: 'max-content' },
  rowClassName,
  rowKey,
  className = '',
  ...restProps
}) => {
  const defaultRowClassName = (record) => {
    if (record.isDateGroup) {
      return styles.dateGroupRow;
    }
    if (record.isSubtotal) {
      return styles.subtotalRow;
    }
    return styles.tableRow;
  };

  return (
    <div className={styles.tableWrapper}>
      <Table
        className={`${styles.commonTable} ${className}`}
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}
        bordered={bordered}
        size={size}
        scroll={scroll}
        rowClassName={rowClassName || defaultRowClassName}
        rowKey={rowKey}
        {...restProps}
      />
    </div>
  );
};

export default CommonTable;
